import React from 'react'
import IconReusable from '../../components/IconReusable'
import { Box, Typography, useMediaQuery } from '@mui/material'
import { CustomButton } from '../../v2/MUI_custom_component';

const OnboardingContainer = ({ children, ShowIcon = false, navigation, title, buttonHandler }) => {
  const isMobile = useMediaQuery('(max-width: 600px)');
    
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        maxWidth: '600px',
        p: 2,
        m: 'auto',
        height: '100vh',
        overflow: 'hidden',
        position: 'relative',
      }}
    >
      {/* Header */}
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          {ShowIcon && (
            <IconReusable 
                name="ArrowBack" 
                size={24} 
                color="#333" 
                onClick={navigation}
                style={{ cursor: 'pointer' }}
            />
          )}
          <Typography variant='h1' sx={{ color: '#666666' }}>
              {title}
          </Typography>
        </Box>
        <CustomButton
          label='Skip'
          variant='text'
          color='primary'
          onClick={buttonHandler}
        />
      </Box>
      
      {/* Scrollable Content Area */}
      <Box 
        sx={{ 
          flex: 1, 
          overflowY: 'auto',
          display: 'flex',
          flexDirection: 'column',
          gap: 2,
          paddingRight: 1,
          scrollbarWidth: 'none',
          '&::-webkit-scrollbar': { display: 'none' },
        }}
      >
        {children}
      </Box>
    </Box>
      
  )
}

export default OnboardingContainer